/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Confirmndasigned3Inputs */

const en_coinvestments_tracking_confirmndasigned3 = /** @type {(inputs: Coinvestments_Tracking_Confirmndasigned3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm NDA Signed`)
};

/**
* | output |
* | --- |
* | "Confirm NDA Signed" |
*
* @param {Coinvestments_Tracking_Confirmndasigned3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_confirmndasigned3 = /** @type {((inputs?: Coinvestments_Tracking_Confirmndasigned3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Confirmndasigned3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_confirmndasigned3(inputs)
});
export { coinvestments_tracking_confirmndasigned3 as "coInvestments_tracking_confirmNdaSigned" }